module.exports = __webpack_public_path__ + "officialStatic/img/product-swgk.345b6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-swgk.png
// module id = X3xA
// module chunks = 0